import baseTheme from '../light';

export default {
  ...baseTheme,
  nav: {
    ...baseTheme.nav,
    button: {
      bg: '#6cabae',
      text: 'white',
    },
    logo: {
      src: '/whitelabel/sb/Scotiabank_logo.svg',
      height: '40px',
      marginRight: '10px',
      marginLeft: '10px',
    },
  },
  header: {
    backgroundImage: '/whitelabel/sb/bg@2x.png',
  },
};
